import script from "./Upgrade16167.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upgrade16167.vue?vue&type=script&setup=true&lang=ts"

import "./Upgrade16167.vue?vue&type=style&index=0&id=ba30d2a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba30d2a0"]])

export default __exports__